/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step6_AiInputs */

const en_dr_step6_ai = /** @type {(inputs: Dr_Step6_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drafts the wizard content; participants click "Approve the formulation"`)
};

const id_dr_step6_ai = /** @type {(inputs: Dr_Step6_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyusun isi wizard; peserta menekan "Setujui rumusan"`)
};

/**
* | output |
* | --- |
* | "Drafts the wizard content; participants click \"Approve the formulation\"" |
*
* @param {Dr_Step6_AiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step6_ai = /** @type {((inputs?: Dr_Step6_AiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step6_AiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step6_ai(inputs)
	return en_dr_step6_ai(inputs)
});